var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0531 17.0002H1.95362C1.68854 17.0002 1.43428 16.895 1.24669 16.7077C1.05911 16.5203 0.953522 16.2663 0.953125 16.0012C0.953384 15.8272 0.99832 15.6563 1.08362 15.5047L9.13262 1.41066C9.19769 1.29647 9.28465 1.19625 9.38852 1.11572C9.49239 1.0352 9.61112 0.975959 9.73793 0.941402C9.86473 0.906845 9.9971 0.897648 10.1275 0.914338C10.2578 0.931028 10.3836 0.973277 10.4976 1.03866C10.6531 1.12654 10.7817 1.25515 10.8696 1.41066L18.9186 15.5107C19.0068 15.6628 19.0533 15.8356 19.0533 16.0114C19.0534 16.1873 19.007 16.36 18.9189 16.5122C18.8308 16.6644 18.704 16.7907 18.5515 16.8782C18.3989 16.9657 18.226 17.0114 18.0501 17.0107L18.0531 17.0002ZM9.09212 13.3852V15.1852H10.9116V13.3852H9.09212ZM9.00062 6.00516L9.50312 12.4222H10.4916L11.0031 6.01416L9.00062 6.00516Z",
    fill: "#FFA32B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.7c4bc776793d101dcef500f4fb9635ef.svg";
export { ForwardRef as ReactComponent };